import { GET_YEAR_SUCCESS, GET_YEAR_ERROR, GET_TEAM_SUCCESS, GET_TEAM_ERROR } from '../actions/metadata';

const initState = {
    years: [],
    teams: [],
    leagues: {
        central: [],
        pacific: [],
    },
    error: {},
};

export default (state = initState, action) => {
    switch (action.type) {
        case GET_YEAR_SUCCESS:
            return {
                ...state,
                years: action.data
            };
        case GET_YEAR_ERROR:
            return {
                ...state,
                error: action.error,
            };
        case GET_TEAM_SUCCESS:
            return {
                ...state,
                teams: action.data,
                leagues: action.leagues
            };
        case GET_TEAM_ERROR:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};
